var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canWriteModelRegistry)?_c('model-create'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }